// @ts-nocheck
import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useReportingMap } from 'sonata-platform-components';
import { HeatmapSettings, Map as MapComponent } from 'sonata-platform-components/lib/types/types/reportingMap.types';
import { Range } from 'sonata-react-components';
import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';

import { getUserRoles } from '@/store/selectors/resources.selectors';
import { getCurrentUser } from '@/store/selectors/user.selectors';

type Props = {
  mapId: MapComponent['id'];
};

export const HeatMapAdvanceSettings: React.VFC<Props> = ({ mapId }) => {
  const { formatMessage } = useIntl();
  const user = useSelector(getCurrentUser);
  const userRoles = useSelector(getUserRoles);

  const { getMap, setMapSettings } = useReportingMap();
  const map = getMap({ id: mapId });

  const { settings, type } = map!;

  const setSettingProp = useCallback(
    (field, value) => {
      setMapSettings({
        id: mapId,
        value: {
          ...settings,
          [type]: {
            ...settings[type],
            [field]: value
          }
        }
      });
    },
    [setMapSettings, settings, type]
  );

  const currentSettings = useMemo(() => settings[type] as HeatmapSettings, [settings, type]);

  if (!checkUserResourcePermissions('reportingHeatMapAdvanceSettings', user, userRoles)) {
    return null;
  }
  return (
    <>
      <div className="innerControls__heatmapSliderWrapper">
        <Range
          id={`${mapId}-reporting-heatmap-radious`}
          max={100}
          min={1}
          onChange={value => setSettingProp('radius', value / 100)}
          type="slider"
          value={currentSettings.radius * 100}
        >
          <Range.Label>
            {formatMessage({
              defaultMessage: 'Radius',
              id: 'reporting.map.innerControls.variableSettings.radiusSliderLabel'
            })}
          </Range.Label>
          <Range.Bar />
        </Range>
      </div>
      <div className="innerControls__heatmapSliderWrapper">
        <Range
          id={`${mapId}-reporting-heatmap-intensity`}
          max={100}
          min={1}
          onChange={value => setSettingProp('intensity', value / 100)}
          type="slider"
          value={currentSettings.intensity * 100}
        >
          <Range.Label>
            {formatMessage({
              defaultMessage: 'Intensity',
              id: 'reporting.map.innerControls.variableSettings.intensitySliderLabel'
            })}
          </Range.Label>
          <Range.Bar />
        </Range>
      </div>
    </>
  );
};
